import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Styles
import './styles/global.css';

// Pages
import Home from './pages/Home';
// Phase-1 launch: login disabled
// import Login from './pages/Login';
import Signup from './pages/Signup';
// Phase-1 launch: booking handled by external Healthplix link
// import BookAppointment from './pages/BookAppointment';
import Contact from './pages/Contact';
// Phase-1 launch: patient dashboard disabled
// import PatientDashboard from './pages/PatientDashboard';
// import MedicalRecords from './pages/MedicalRecords';
// import Progress from './pages/Progress';
// import Consultations from './pages/Consultations';
// import Settings from './pages/Settings';
import NotFound from './pages/NotFound';
import ForgotPassword from './pages/ForgotPassword';
import ArticlesGuides from './pages/ArticlesGuides';
import ArticleDetail from './pages/ArticleDetail';
import SelfAssessment from './pages/SelfAssessment';
import Journal from './pages/Journal';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Phase-1 launch: login disabled */}
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* Phase-1 launch: booking handled by external Healthplix link */}
        {/* <Route path="/book" element={<BookAppointment />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/resources/articles" element={<ArticlesGuides />} />
        <Route path="/resources/articles/:slug" element={<ArticleDetail />} />
        <Route path="/resources/self-assessment" element={<SelfAssessment />} />
        <Route path="/resources/journal" element={<Journal />} />
        {/* Phase-1 launch: dashboard disabled */}
        {/* <Route path="/dashboard" element={<PatientDashboard />} /> */}
        {/* <Route path="/dashboard/book" element={<BookAppointment />} /> */}
        {/* <Route path="/dashboard/records" element={<MedicalRecords />} /> */}
        {/* <Route path="/dashboard/progress" element={<Progress />} /> */}
        {/* <Route path="/dashboard/consult" element={<Consultations />} /> */}
        {/* <Route path="/dashboard/settings" element={<Settings />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
